import { vservice } from '@niknevis/vue-modules'
import { AdminContentItemService } from '@/modules/content-item/services/admin-content-item.service'
import { ContentItemSaveContentRequestModelInAdmin } from '@/modules/content-item/models/content-item-request.model'

@vservice()
export class AdminContentItemSaveContentUseCase {
  constructor(
    private readonly service: AdminContentItemService
  ) {
  }

  private loadingState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  execute(contentItemId: number, data: ContentItemSaveContentRequestModelInAdmin) {
    return this.service.saveContent(contentItemId, data)
      .onStart(() => {
        this.loadingState = true
      })
      .onFinish(() => {
        this.loadingState = false
      })
  }
}
